import React from 'react';
// import TextField from '@material-ui/core/TextField'
import TextField from '@mui/material/TextField'
import { useField } from 'formik';

const AddUserTextfieldWrapper = ({
  name,
  ...otherProps
}) => {
  const [field, mata] = useField(name);


  const configTextfield = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: 'outlined',
    margin: "normal",
    size: 'small'
  };

  if (mata && mata.touched && mata.error) {
    configTextfield.error = true;
    configTextfield.helperText = mata.error;
  }

  return (

    <TextField
      autoComplete="off"
      sx={{
        "& .MuiInputBase-root": {
          height: 45

        }
      }}
      {...configTextfield}
    />

  );
};

export default AddUserTextfieldWrapper;